import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from 'react';
import clamp from 'lodash/clamp';
import range from 'lodash/range';
import { Pagination } from '@cancercentrum/rcc-bootstrap';
import { useI18n } from '../../i18n';
const MAX_BUTTONS = 5;
const BTNS_PER_SITE = Math.floor(5 / 2);
export const Pager = (props)=>{
    const { items, activePage, onSelect } = props;
    const firstPage = Math.max(Math.min(activePage - BTNS_PER_SITE, items - MAX_BUTTONS + 1), 1);
    const lastPage = clamp(firstPage + MAX_BUTTONS - 1, 1, items);
    const pitems = range(firstPage, lastPage + 1).map((nr)=>{
        return /*#__PURE__*/ _jsx(Pagination.Item, {
            active: activePage === nr,
            onClick: ()=>onSelect(nr),
            children: nr
        }, nr);
    });
    const { t } = useI18n();
    const firstText = t('component.grid.pager.first');
    const lastText = t('component.grid.pager.last');
    const nextText = t('component.grid.pager.next');
    const prevText = t('component.grid.pager.prev');
    return /*#__PURE__*/ _jsxs(Pagination, {
        bsSize: "sm",
        align: "right",
        "data-testid": "GridPager",
        children: [
            items > MAX_BUTTONS && /*#__PURE__*/ _jsxs(Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Pagination.First, {
                        disabled: activePage === 1,
                        onClick: onSelect.bind(this, 1),
                        children: firstText
                    }),
                    /*#__PURE__*/ _jsx(Pagination.Prev, {
                        disabled: activePage === 1,
                        onClick: onSelect.bind(this, activePage - 1),
                        children: prevText
                    })
                ]
            }),
            firstPage !== 1 && /*#__PURE__*/ _jsx(Pagination.Ellipsis, {}),
            pitems,
            lastPage !== items && /*#__PURE__*/ _jsx(Pagination.Ellipsis, {}),
            items > MAX_BUTTONS && /*#__PURE__*/ _jsxs(Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Pagination.Next, {
                        disabled: activePage === items,
                        onClick: onSelect.bind(this, activePage + 1),
                        children: nextText
                    }),
                    /*#__PURE__*/ _jsx(Pagination.Last, {
                        disabled: activePage === items,
                        onClick: onSelect.bind(this, items),
                        children: lastText
                    })
                ]
            })
        ]
    });
};
